import { ReactNode } from 'react';
import useScrollReveal from '@/hooks/useScrollReveal';

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  threshold?: number;
  animation?: 'fade-up' | 'fade-in' | 'fade-left' | 'fade-right';
}

const animations = {
  'fade-up': 'translate-y-10 opacity-0',
  'fade-in': 'opacity-0',
  'fade-left': '-translate-x-10 opacity-0',
  'fade-right': 'translate-x-10 opacity-0',
};

export default function AnimatedSection({
  children,
  className = '',
  threshold = 0.12,
  animation = 'fade-up',
}: AnimatedSectionProps) {
  const { ref, isVisible } = useScrollReveal(threshold);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        isVisible ? 'translate-y-0 translate-x-0 opacity-100' : animations[animation]
      } ${className}`}
    >
      {children}
    </div>
  );
}